import React, { useEffect, useState } from 'react';
const comparisonRows = [{
  without: '100+ horas/año planificando desde cero',
  with: '10 min/semana. El resto es atender.'
}, {
  without: 'Sesiones improvisadas → sin criterio clínico',
  with: '144 sesiones listas con objetivo y cierre'
}, {
  without: '60% de familias abandonan antes del año',
  with: 'Sistema de seguimiento → adherencia +75%'
}, {
  without: 'Sin progresión clara por etapa',
  with: '6 tomos secuenciados → progresan y recomiendan'
}, {
  without: 'Cancelación = sesión perdida',
  with: 'Reglamento + contrato listos para usar'
}, {
  without: 'Informes que tardan horas',
  with: 'Reporte en 1 página en 5 min'
}, {
  without: 'Cobro irregular e incómodo',
  with: 'Abono blindado → cobro el día 1-5'
}, {
  without: 'Sin identidad profesional',
  with: 'Sistema que justifica cobrar 30-50% más'
}, {
  without: 'Sin guiones para familias',
  with: 'Scripts listos para WhatsApp y cierre de sesión'
}];
export function DarkCTA() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 26,
    seconds: 56
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) return {
          hours: 0,
          minutes: 0,
          seconds: 0
        };
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => String(n).padStart(2, '0');
  return <section className="w-full px-4 py-16 sm:py-20 text-gray-900 text-base leading-6" style={{
    backgroundColor: 'rgb(248, 250, 252)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-87">
      <div className="mx-auto max-w-4xl text-center" data-id="element-88">

        {/* Brand */}
        <div className="mb-8 text-2xl sm:text-3xl font-black tracking-[3px] text-cyan-brand" data-id="element-89">
          👶 MÉTODO INTEGRAL™
        </div>

        {/* Headlines */}
        <h2 className="text-xl sm:text-3xl font-bold text-gray-900 m-0 mb-3" data-id="element-90">
          La próxima sesión podés volver a improvisar.
        </h2>
        <p className="text-xl sm:text-3xl font-black text-cyan-brand m-0 mb-10" data-id="element-91">
          O podés entrar al lunes con todo resuelto desde hoy.
        </p>

        {/* Comparison Table */}
        <div className="mx-auto max-w-2xl mb-12 overflow-hidden rounded-2xl border border-gray-200 text-left" style={{
        backgroundColor: 'rgb(255, 255, 255)'
      }} data-id="element-92">
          {/* Table Title */}
          <div className="text-center font-bold text-gray-900 border-b border-gray-200 px-4 py-4" style={{
          backgroundColor: 'rgb(243, 244, 246)'
        }} data-id="element-93">
            ¿Cuánto cuesta NO tenerlo?
          </div>

          {/* Table Header */}
          <div className="grid grid-cols-2 border-b border-gray-200" style={{
          backgroundColor: 'rgb(243, 244, 246)'
        }} data-id="element-94">
            <div className="text-center font-bold text-gray-500 px-4 py-3 text-sm" data-id="element-95">
              SIN MEGAPACK
            </div>
            <div className="text-center font-bold text-cyan-brand border-l border-gray-200 px-4 py-3 text-sm" data-id="element-96">
              CON MEGAPACK
            </div>
          </div>

          {/* Rows */}
          {comparisonRows.map((row, i) => <div key={i} className={`grid grid-cols-2 ${i < comparisonRows.length - 1 ? 'border-b border-gray-100' : ''}`} data-id="element-97">
              <div className="px-4 py-3 text-xs sm:text-sm text-gray-500" data-id="element-98">
                {row.without}
              </div>
              <div className="px-4 py-3 text-xs sm:text-sm font-bold text-gray-900 border-l border-gray-100" style={{
            backgroundColor: 'rgba(0, 180, 216, 0.05)'
          }} data-id="element-99">
                {row.with}
              </div>
            </div>)}
        </div>

        {/* Countdown */}
        <div className="mb-4" data-id="element-100">
          <p className="font-bold text-gray-900 m-0 mb-4" data-id="element-101">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <div className="flex items-center justify-center gap-0" data-id="element-102">
            <div className="flex flex-col items-center" data-id="element-103">
              <span className="text-5xl sm:text-7xl font-black tabular-nums animate-countdown-blink will-change-[opacity] text-[rgb(255,68,68)]" data-id="element-104">
                {pad(timeLeft.hours)}
              </span>
              <span className="text-xs sm:text-sm uppercase tracking-wide text-gray-500" data-id="element-105">
                hs
              </span>
            </div>
            <span className="mb-4 text-5xl sm:text-7xl font-black animate-countdown-blink will-change-[opacity] text-[rgb(255,68,68)]" data-id="element-106">
              :
            </span>
            <div className="flex flex-col items-center" data-id="element-107">
              <span className="text-5xl sm:text-7xl font-black tabular-nums animate-countdown-blink will-change-[opacity] text-[rgb(255,68,68)]" data-id="element-108">
                {pad(timeLeft.minutes)}
              </span>
              <span className="text-xs sm:text-sm uppercase tracking-wide text-gray-500" data-id="element-109">
                min
              </span>
            </div>
            <span className="mb-4 text-5xl sm:text-7xl font-black animate-countdown-blink will-change-[opacity] text-[rgb(255,68,68)]" data-id="element-110">
              :
            </span>
            <div className="flex flex-col items-center" data-id="element-111">
              <span className="text-5xl sm:text-7xl font-black tabular-nums animate-countdown-blink will-change-[opacity] text-[rgb(255,68,68)]" data-id="element-112">
                {pad(timeLeft.seconds)}
              </span>
              <span className="text-xs sm:text-sm uppercase tracking-wide text-gray-500" data-id="element-113">
                seg
              </span>
            </div>
          </div>
        </div>

        <p className="text-sm text-gray-600 m-0 mb-12" data-id="element-114">
          Después sube{' '}
          <span className="font-bold text-red-500" data-id="element-115">$8.000 ARS</span> y no
          vuelve.
        </p>

        {/* Two Pricing Cards */}
        <div className="mx-auto max-w-2xl mb-10 grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-116">

          {/* Standard — MEGAPACK ESTIMULACIÓN TEMPRANA */}
          <div className="flex flex-col rounded-xl p-6 border border-gray-200 shadow-sm" style={{
          backgroundColor: 'rgb(255, 255, 255)'
        }} data-id="element-117">
            <div className="mb-2 text-2xl" data-id="element-118">👶</div>
            <h3 className="text-base font-black text-gray-900 m-0 mb-1" data-id="element-119">
              MEGAPACK ESTIMULACIÓN TEMPRANA
            </h3>
            <p className="text-xs text-gray-500 m-0 mb-4" data-id="element-120">
              6 Tomos + 6 Bonos
            </p>
            <div className="mt-auto" data-id="element-121">
              <p className="text-sm text-gray-500 line-through m-0 mb-1" data-id="element-122">
                Antes: $58.990 ARS
              </p>
              <p className="text-2xl font-black text-cyan-brand m-0 mb-4" data-id="element-123">
                Hoy: $19.990 ARS
              </p>
              <a href="https://checkout.construyeprogreso.com/cart/48185772966058:1" onClick={() => {
              if (typeof window !== 'undefined' && (window as any).fbq) {
                ;
                (window as any).fbq('track', 'InitiateCheckout', {
                  content_name: 'Megapack Estimulación Temprana',
                  content_category: 'Estimulación Temprana',
                  value: 19990,
                  currency: 'ARS'
                });
              }
            }} className="block bg-cyan-brand text-white text-center text-sm font-black rounded-lg py-4 no-underline transition-colors animate-pulse-green will-change-transform" data-id="element-124">
                → QUIERO MI MEGAPACK
              </a>
            </div>
          </div>

          {/* Pro — MEGAPACK + MÉTODO INTEGRAL */}
          <div className="flex flex-col rounded-xl p-6 border-2 border-cyan-brand shadow-sm" style={{
          backgroundColor: 'rgb(240, 249, 255)',
          boxShadow: 'rgba(0, 180, 216, 0.15) 0px 0px 30px 0px'
        }} data-id="element-125">
            <div className="mb-2 text-2xl" data-id="element-126">🏆</div>
            <h3 className="text-base font-black text-cyan-brand m-0 mb-1" data-id="element-127">
              MEGAPACK + MÉTODO INTEGRAL ⭐
            </h3>
            <p className="text-xs text-gray-500 m-0 mb-1" data-id="element-128">La más elegida</p>
            <p className="text-xs text-gray-500 m-0 mb-4" data-id="element-129">
              6 Tomos + 6 Bonos + Método Integral™
              <br data-id="element-130" />
              (cobro, gestión, informes y negocio)
            </p>
            <div className="mt-auto" data-id="element-131">
              <p className="text-sm text-gray-500 line-through m-0 mb-1" data-id="element-132">
                Antes: $102.990 ARS
              </p>
              <p className="text-3xl font-black text-cyan-brand m-0 mb-4" data-id="element-133">
                Hoy: $27.990 ARS
              </p>
              <a href="https://checkout.construyeprogreso.com/cart/48185777684650:1" onClick={() => {
              if (typeof window !== 'undefined' && (window as any).fbq) {
                ;
                (window as any).fbq('track', 'InitiateCheckout', {
                  content_name: 'Megapack + Método Integral',
                  content_category: 'Estimulación Temprana',
                  value: 27990,
                  currency: 'ARS'
                });
              }
            }} className="block bg-cyan-brand text-white text-center text-sm font-black rounded-lg py-4 no-underline transition-colors animate-pulse-green will-change-transform" data-id="element-134">
                → QUIERO EL MEGAPACK + MÉTODO INTEGRAL
              </a>
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-600" data-id="element-135">
          <span data-id="element-136">🔒 Pago 100% seguro</span>
          <span data-id="element-137">⚡ Acceso en 5 minutos</span>
          <span data-id="element-138">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-139">💳 Mercado Pago | Tarjeta | Transferencia</span>
        </div>

      </div>
    </section>;
}